import { SupportCategory } from "../../contexts/support-types";
import { apiProvider } from "./utilities/provider";
import { JsonDocument } from "./utilities/json";

export const supportContentApi = {
  getAll: (): Promise<SupportCategory[]> =>
    apiProvider
      .getAll("support-content")
      .then((d: JsonDocument<SupportCategory[]>) => d.data),
};
